<template>
    <div class="card">
        <div class="col-12 px-2 mt-2 mb-4">
            <div class="card p-2" style="min-height: 200px">
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Dental Service No</th>
                                <th>Invoice No</th>
                                <th>Invoice Date</th>
                                <th>Invoice Amount</th>
                                <th>Paid Amount</th>
                                <th>Print</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, i) in tableItems" :key="i">
                                <tr>
                                    <td>{{ item.admission_no }})</td>
                                    <td>{{ item.bill_number }}</td>
                                    <td>{{ item.date }}</td>
                                    <td>{{ item.total_amount }}</td>
                                    <td>{{ item.paid_amount }}</td>
                                    <td class="d-flex">
                                        <button @click="goToPrintSummary(item.id)" class="btn btn-sm p-0"><i class="fas fa-print"></i> Summary </button> 
                                        <!-- TODO:: will be used later -->
                                        <!-- <button class="btn btn-sm p-0"><i class="fas fa-print"></i> Details</button> -->
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
                </div>
            </div>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import {inject, onMounted, ref, watch} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleDentalOs from '@/services/modules/dental-os/dentalOs';
import handleCompany from "@/services/modules/company";
import handleHospital from '@/services/modules/hospital';
import ipdStatementHelper from "@/services/utils/pdf/dental/ipdStatementHelper";

const { fetchPatientBilling } = handleDentalOs();
const { fetchCompanyInfo } = handleCompany();
const { fetchIpdStatement } = handleHospital();
const { generatePdf } = ipdStatementHelper();

const route = useRoute();

const loading = ref(false)
const tableItems = ref([]);
const companyInfo = ref({});
const patientDetails = ref({});
const service = ref([]);
const receiptGenerals = ref([]);
const total = ref({});

const getPatientBilling = async () => {
    const query = getQuery();
    const contactId = route.query.contactId || null;

    loading.value = true

    tableItems.value = []

    await fetchPatientBilling(contactId, query).then(res => {
        if (!res.status) return;
        tableItems.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const goToPrintSummary = async (id) => {
    let query = `/${id}?company_id=${route.params.companyId}`;

    loading.value = true

    await fetchIpdStatement(query).then((res) => {
        patientDetails.value = res.data;
        service.value = res.service_data;
        receiptGenerals.value = res.receipt_generals;
        total.value = res.total;
        total.value.settlement_discount = res.data.settlement_discount;


        generatePdf(
            companyInfo.value, 
            patientDetails.value, 
            service.value, 
            receiptGenerals.value, 
            total.value, 
            true
        )
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {

    let query = `?company_id=${route.params.companyId}`;
    return query;
}

const getCompanyInfo = async () => {
    await fetchCompanyInfo(route.params.companyId).then((res) => {
        companyInfo.value = res.data
    })
}

const getCompanyQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    return query;
}

watch(() => route.query.contactId, () => {
    getPatientBilling()
}, { immediate: true, deep: true });

onMounted(() => {
    getCompanyInfo()
})
</script>
